import React, { useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import { navigate, useLocation } from "@reach/router";
import { getIdFromUrl } from "../../../helpers/functions";
import labels from "../../../helpers/labels.json";
import useStatus from "../../../hooks/useStatus";
import { Layout } from "../../../styles/component/style";

export default function TemporaryRoute({
  showSidebar = true,
  selectedItem,
  selectedSubItem,
  children,
}) {
  const location = useLocation();
  const { globalId, setGlobalId } = useStatus();

  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  const getRelevantSegments = (url) => {
    const cleanUrl = url.split(/[?#]/)[0];

    // Split by "/" and get last non-empty segment
    const segments = cleanUrl.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    return lastSegment;
  };

  /**
   * @description maintain global id hook
   */

  useEffect(() => {
    if (getIdFromUrl(location.pathname) > 0 && lastSegment && !globalId) {
      setGlobalId(lastSegment);
    } else if (getIdFromUrl(location.pathname) === 0 && globalId) {
      navigate(`${location.pathname}/${globalId}`);
    }
    if (
      selectedItem === "dashboard" ||
      selectedItem === labels.event_host ||
      selectedItem === labels.organisation ||
      selectedItem === labels.events ||
      selectedItem === labels.downloads ||
      selectedItem === labels.home
    ) {
      setGlobalId("");
      navigate(location.pathname);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Header
        {...{ showSidebar, selectedSubItem }}
        selectedItem={
          location.pathname.includes("event-details")
            ? getIdFromUrl(location.pathname) > 0
              ? labels.event_details
              : selectedItem
            : getRelevantSegments(location.pathname) === "events"
            ? "Events"
            : getRelevantSegments(location.pathname) === "tab"
            ? "Events"
            : getRelevantSegments(location.pathname) === "tab"
            ? "dashboard"
            : "dashboard"
        }
      >
        {children}
      </Header>
    </Layout>
  );
}
